// src/components/AddLocationModal.js
import React, { useEffect } from 'react';
import { Modal, Form, Input, Button, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  addLocation,
  closeModal,
  resetAddStatus,
  fetchLocations
} from '../../slices/locationSlice';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

const AddLocationModal = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const isVisible = useSelector(state => state.locations.isModalVisible);
  const addStatus = useSelector(state => state.locations.addStatus);
  const [form] = Form.useForm();

  const handleFormSubmit = () => {
    form.validateFields().then(values => {
      dispatch(addLocation(values)).then(() => {
        dispatch(fetchLocations()); // Re-fetch all locations
        form.resetFields(); // Reset form
        dispatch(resetAddStatus()); // Reset add status
      });
    });
  };

  const handleCancel = () => {
    dispatch(closeModal());
    form.resetFields(); // Clear form fields when modal is closed
    dispatch(resetAddStatus()); // Reset addStatus on modal close
  };

  // Reset addStatus when form submission completes (succeeded or failed)
  useEffect(() => {
    if (addStatus === 'succeeded' || addStatus === 'failed') {
      dispatch(resetAddStatus());
    }
  }, [addStatus, dispatch]);

  return (
    <Modal
      title={t('Location hinzufügen')}
      visible={isVisible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          {t('Abbrechen')}
        </Button>,
        <Button
          key="submit"
          type="primary"
          style={{ backgroundColor: 'black' }}
          className="btn card-first-btn"
          loading={addStatus === 'loading'}
          onClick={handleFormSubmit}
        >
          {t('OK')}
        </Button>
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label={t('Name')}
          rules={[
            { required: true, message: t('Bitte Name der Location eingeben') }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="address"
          label={t('Adresse')}
          rules={[{ required: false, message: t('Bitte Adresse eingeben') }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="description"
          label={t('Beschreibung')}
          rules={[{ required: false, message: t('Bitte Beschreibung eingeben') }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        {/* Select Field for Location Type */}
        <Form.Item
          name="type"
          label={t('Typ')}
          rules={[
            { required: true, message: t('Bitte Typ der Location auswählen') }
          ]}
        >
          <Select placeholder={t('Typ auswählen')}>
            <Option value="room">{t('Raum')}</Option>
            <Option value="building">{t('Gebäude')}</Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddLocationModal;
